module.exports = __webpack_public_path__ + "img/ifs_partner.e46a35bd.png";